import React, { useEffect } from "react";
import useRedirect from "./useRedirect";
import cookie from "js-cookie";

export const Redirect = () => {
  const { redirect } = useRedirect();

  useEffect(() => {
    const url = cookie.get("url");
    const title = cookie.get("title") || "Dolda fel";

    cookie.remove('url');
    cookie.remove('title');
    if (url && title) {
      redirect(title, url);
    }
  }, []);

  return <></>;
};
